export enum PasswordResetType {
  PhoneNumber = 'phone_number',
  Mail = 'mail',
}
